import * as React from "react";


export const SelectRaw = (
    {
        list,className = undefined, valueToLabel = v=>v, isSelected = (v)=>false, onChange = undefined,
        placeholder = undefined, xdQaName=undefined,
        ...props
    }) => (
    <select
        {...props}
        className={className}
        value={(list && list.findIndex(isSelected)) || ""}
        xd-qa-type="dropdown"
        xd-qa-name={xdQaName}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onChange(list[e.target.value])}
    >
        {(!list || list.findIndex(isSelected) === -1) && (
            <option value="">{placeholder}</option>
        )}
        {list && list.map((v, i) => (
            <option key={i} value={i} xd-qa-type="dropdown_item" xd-qa-name={valueToLabel(v)+" "+xdQaName}>{valueToLabel(v)}</option>
        ))}
    </select>
);
